module.exports = __webpack_public_path__ + "img/project_bg1.bab72a07.png";